import { ShippingFrecuency as ShippingFrecuencyPage } from "@/pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/register/shipping-frecuency")({
  component: ShippingFrecuencyPage,
  beforeLoad: () => {
    document.title = "Maifud - Registro Frecuencía";
  },
});
